import React from 'react';
import { compose } from '../../../../../../utils/component-helpers';

// Receiver helpers
import { statuses } from '@cube3/state/src/redux/ducks/request-status';
import { withResourceEdges } from '@cube3/state/src/redux/components/withResourceEdges';
import { Asset } from '@cube3/common/model/schema/resources/asset';
import { MetadataForm } from '@cube3/common/model/schema/resources/metadata-category';

// import MetadataFormRenderer from '../MetaData/MetadataForm';
import { MetadataReadOnlySmart } from '../MetaData/MetadataReadOnlySmart';
import MetadataOverviewCommandBar from '../CommandBar/MetadataOverviewCommandBar';

// UI

import DetailViewMetadataUI from '@cube3/ui/src/detailView/MetaData/DetailviewMetadataUI';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography/Typography';

/// @ Author : Simon @AmbassadorsLab (original metadata component made by michiel)
/// <Summary>
/// Detailview tab for metadata information about asset in
/// </Summary>

// check this

interface HOCmapped {
  // from withresourceEdges.
  retrievedFormsStatus: string;
  retrievedForms: MetadataForm[];
}

interface Properties extends HOCmapped {
  asset: Asset;
}

const DetailViewMetaData: React.FC<Properties> = (props) => {
  const { retrievedForms = [], retrievedFormsStatus, asset } = props;

  return (
    <DetailViewMetadataUI
      retrievedForms={retrievedForms}
      loading={retrievedFormsStatus === statuses.SUCCESS ? false : true}
      renderPropsCommandBar={
        retrievedForms && retrievedForms.length > 0
          ? () => <MetadataOverviewCommandBar />
          : undefined
      }
      renderMetaDataForms={() => (
        <>
          {(!retrievedForms || !retrievedForms.length) && (
            <Typography>No metadata categories available</Typography>
          )}

          {retrievedForms &&
            retrievedForms.map((form) => (
              <MetadataReadOnlySmart
                key={form.id}
                metadataFormId={form.id}
                metadataForResource={{ type: 'asset', id: asset.id }}
              />
            ))}
        </>
      )}
    />
  );
};

export default compose(DetailViewMetaData)(
  withResourceEdges({
    resourceType: 'asset',
    resourceId: (props: Properties) => props.asset.id,
    edgeType: 'metadata-category',
    edgeLabel: 'metadata-categories',
    mapper: 'retrievedForms'
  })
);
